// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"index-module--rectangle--27G8d","logo":"index-module--logo--3LMB_"};